module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [_c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topLeft.x,
      "x2": _vm.topRight.x,
      "y1": _vm.topLeft.y,
      "y2": _vm.topRight.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topLeft.x,
      "x2": _vm.bottomLeft.x,
      "y1": _vm.topLeft.y,
      "y2": _vm.bottomLeft.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.topRight.x,
      "x2": _vm.topRight.x,
      "y1": _vm.topRight.y,
      "y2": _vm.bottomRight.y
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "ko-marker",
    attrs: {
      "x1": _vm.bottomLeft.x,
      "x2": _vm.bottomRight.x,
      "y1": _vm.bottomLeft.y,
      "y2": _vm.bottomRight.y
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6138641e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/game/KoMarker.vue
// module id = 420
// module chunks = 1